!function() {
  class e extends HTMLElement {
    constructor() {
      super(), window.Shopify = window.Shopify || {}, window.Shopify.recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [], 
      this.container = this.querySelector("[data-slider]");
    }
    connectedCallback() {
      this.container && window.Shopify.recentlyViewed && window.Shopify.recentlyViewed.length > 0 && this.loadProducts();
    }
    loadProducts() {
      window.Shopify.recentlyViewed.forEach(e => {
        const t = e.trim();
        this.loadProduct(t.split("#")[0]);
      });
    }
    show() {
      this.classList.remove("hidden");
    }
    removeItem(e) {
      window.Shopify.recentlyViewed = window.Shopify.recentlyViewed.filter(t => t !== e), 
      localStorage.setItem("recentlyViewed", JSON.stringify(window.Shopify.recentlyViewed));
    }
    async loadProduct(e) {
      const t = location.href.match("/products/([^?]+)"), o = t ? t[1] : null;
      o && e === o || fetch(`${window.Shopify?.routes?.root || "/"}products/${e}?view=card`).then(t => {
        if (!t.ok) throw this.removeItem(e), Error(t.statusText);
        return t.text();
      }).then(t => {
        const o = (new DOMParser).parseFromString(t, "text/html").body.firstElementChild;
        if (!o) throw this.removeItem(e), Error("No product card found");
        {
          const e = document.createElement("div");
          e.classList.add("slide", "w-grid", "[--columns:4]", "tablet:[--columns:calc(12/7)]"), 
          e.setAttribute("data-slide", !0), e.innerHTML = o.outerHTML, this.container.appendChild(e);
        }
      }).then(() => {
        this.show();
      }).catch(t => {
        console.warn("RecentlyViewed: Could not load product: " + e + ". " + t);
      });
    }
  }
  customElements.get("recently-viewed") || customElements.define("recently-viewed", e);
}();